import { Divider, Typography } from '@mui/material';
import { INCOME_OR_EXPENSE_LIST } from 'adminConstants/routes';
import Page from 'components/new/Page';
import TransactionAllocator from 'components/TransactionAllocator';
import { useLayoutContext } from 'contexts/LayoutContext';
import { CalendarDay } from 'further-ui/utils';
import { Column } from 'further-ui/components/Layout';
import StaticField from 'further-ui/components/StaticField';
import useTransactionTypeSelectorOptions from 'hooks/form/useTransactionTypeSelectorOptions';
import api from 'lib/trpcClient';
import React from 'react';
import { useParams } from 'react-router-dom';
import OriginalActionSummary from './OriginalActionSummary';

const ViewReversalPage: React.FC<{ vehicleId: string }> = ({ vehicleId }) => {
  const { actionId: groupId } = useParams<{ actionId: string }>();
  const { transactionTypeOptions } = useTransactionTypeSelectorOptions();
  const { vehicle } = useLayoutContext();

  const [existingReversal] = api.lpReversal.getReversal.useSuspenseQuery({
    vehicleId,
    actionId: groupId ?? '',
  });

  const reversalLedgerDate = existingReversal
    ? existingReversal.ledgerDate
    : new CalendarDay(new Date());

  const [reversalTransactions] =
    api.lpReversal.getIncomeOrExpenseTransactions.useSuspenseQuery({
      vehicleId,
      groupId: groupId ?? '',
      reversalDate: reversalLedgerDate,
    });

  return (
    <Page
      tabTitle="View Reversal"
      spacing="lg"
      heading="View Reversal"
      withHeadingDivider
      goBackAction={INCOME_OR_EXPENSE_LIST}
    >
      <Column spacing="lg">
        <StaticField label="Reversal date">
          {reversalLedgerDate.toReadable()}
        </StaticField>

        <Divider />

        <Typography variant="h6">Original action</Typography>

        <OriginalActionSummary vehicleId={vehicleId} groupId={groupId ?? ''} />

        <Divider />

        <Typography variant="h6">Account transactions</Typography>

        {vehicle && (
          <TransactionAllocator
            readOnly
            transactions={reversalTransactions}
            transactionTypeOptions={transactionTypeOptions}
            transactionCurrency={vehicle.baseCurrency}
            vehicle={{
              _id: vehicleId,
              baseCurrency: vehicle.baseCurrency,
              fxDataFeed: vehicle.fxDataFeed,
            }}
            fxRate={null}
          />
        )}
      </Column>
    </Page>
  );
};

export default ViewReversalPage;
